<template lang="pug">
.input-going-out-datetime.register-row
  .register-group
    .register-key
      span.key-name {{ keyName }}
      span.validation-label(v-if="required == true") 必須

    .register-value 
      //- year
      select#year.register-form.year(
        name="year"
        v-model="_year"
        v-validate="{ required: required }"
        placeholder="年"
        data-vv-as="年"
        :class="{ noinput: (required == true && !_year), disable: getYearDisable() }"
        :disabled="getYearDisable(showYear)"
      )
        option(v-for="year in years" :value="year.value") {{ year.label }}
      span 年
      //- month
      select#month.register-form.month(
        name="month"
        v-model="_month"
        v-validate="{ required: required }"
        placeholder="月"
        data-vv-as="月"
        :class="{ noinput: (required == true && !_month), disable: getMonthDisabled() }"
        :disabled="getMonthDisabled()"
      )
        option(v-for="month in months") {{ month }}
      span 月
      //- day
      select#day.register-form.day(
        name="day"
        v-model="_day"
        v-validate="{ required: required }"
        placeholder="日"
        data-vv-as="日"
        :class="{ noinput: (required == true && !_day), disable: getDayDisabled() }"
        :disabled="getDayDisabled()"
      )
        option(v-for="day in days") {{ day }}
      span 日
      //- start hour
      select#start-hour.register-form.hour(
        name="start-hour"
        v-model="_startHour"
        v-validate="{ required: required }"
        placeholder="時"
        data-vv-as="時"
        :class="{ noinput: (required == true && !_startHour), disable: getStartHourDisabled() }"
        :disabled="getStartHourDisabled()"
      )
        option(v-for="hour in startHours") {{ hour }}
      span 時
      //- start min
      select#start-min.register-form.min(
        name="start-min"
        v-model="_startMin"
        v-validate="{ required: required }"
        placeholder="分"
        data-vv-as="分"
        :class="{ noinput: (required == true && !_startMin), disable: getStartMinDisabled() }"
        :disabled="getStartMinDisabled()"
      )
        option(v-for="min in startMins") {{ min }}
      span 分

    .register-value.mt-3
      //- separator
      span.mr-2 ～
      //- end hour
      select#end-hour.register-form.hour(
        name="end-hour"
        v-model="_endHour"
        v-validate="{ required: required }"
        placeholder="時"
        data-vv-as="時"
        :class="{ noinput: (required == true && !_endHour), disable: getEndHourDisabled() }"
        :disabled="getEndHourDisabled()"
      )
        option(v-for="hour in endHours") {{ hour }}
      span 時
      //- end min
      select#end-min.register-form.min(
        name="end-min"
        v-model="_endMin"
        v-validate="{ required: required }"
        placeholder="分"
        data-vv-as="分"
        :class="{ noinput: (required == true && !_endMin), disable: getEndMinDisabled() }"
        :disabled="getEndMinDisabled()"
      )
        option(v-for="min in endMins") {{ min }}
      span 分

    .error-messages
      div(v-if="errors.has('year')")
        label.error-message {{ errors.first('year') }}
      div(v-if="errors.has('month')")
        label.error-message {{ errors.first('month') }}
      div(v-if="errors.has('day')")
        label.error-message {{ errors.first('day') }}
      div(v-if="errors.has('start-hour')")
        label.error-message {{ errors.first('start-hour') }}
      div(v-if="errors.has('start-min')")
        label.error-message {{ errors.first('start-min') }}
      div(v-if="errors.has('end-hour')")
        label.error-message {{ errors.first('end-hour') }}
      div(v-if="errors.has('end-min')")
        label.error-message {{ errors.first('end-min') }}
      div(v-if="errors.has('date')")
        label.error-message {{ errors.first('date') }}
      div(v-if="realtimeError != ''")
        label.error-message {{ realtimeError }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

@Component({})
export default class InputGoingOutDatetime extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 項目名 */
  @Prop({ required: true, type: String })
  keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** veevalidateに渡すバリデーション項目名(date用) */
  @Prop({
    default: () => {
      return "年月日";
    },
    type: String
  })
  validationDateKeyName!: string;

  /** 年の入力可否 */
  @Prop({ required: true })
  showYear!: boolean;

  /** 年 */
  @Prop({
    default: ""
  })
  year!: string;

  /** 年の単位 */
  @Prop({ required: true })
  years!: Array<{ label: string; value: number }>;

  /** 月 */
  @Prop({
    default: ""
  })
  month!: string;

  /** 月の単位 */
  @Prop({ required: true })
  months!: Array<string>;

  /** 日 */
  @Prop({
    default: ""
  })
  day!: string;

  /** 日の単位 */
  @Prop({ required: true })
  days!: Array<string>;

  /** 開始時 */
  @Prop({
    default: ""
  })
  startHour!: string;

  /** 開始時の単位 */
  @Prop({ required: true })
  startHours!: Array<string>;

  /** 開始分 */
  @Prop({
    default: ""
  })
  startMin!: string;

  /** 開始分の単位 */
  @Prop({ required: true })
  startMins!: Array<string>;

  /** 終了時 */
  @Prop({
    default: ""
  })
  endHour!: string;

  /** 終了時の単位 */
  @Prop({ required: true })
  endHours!: Array<string>;

  /** 終了分 */
  @Prop({
    default: ""
  })
  endMin!: string;

  /** 終了分の単位 */
  @Prop({ required: true })
  endMins!: Array<string>;

  /** リアルタイムに表示するエラーメッセージ */
  @Prop()
  realtimeError!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _year(): string {
    if (this.year != null) {
      return this.year;
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _year(value: string) {
    this.$emit("update:year", value);
    return;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _month(): string {
    if (this.month != null) {
      return this.month;
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _month(value: string) {
    this.$emit("update:month", value);
    return;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _day(): string {
    if (this.day != null) {
      return this.day;
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _day(value: string) {
    this.$emit("update:day", value);
    return;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _startHour(): string {
    if (this.startHour != null) {
      return this.startHour;
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _startHour(value: string) {
    this.$emit("update:startHour", value);
    return;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _startMin(): string {
    if (this.startMin != null) {
      return this.startMin;
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _startMin(value: string) {
    this.$emit("update:startMin", value);
    return;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _endHour(): string {
    if (this.endHour != null) {
      return this.endHour;
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _endHour(value: string) {
    this.$emit("update:endHour", value);
    return;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _endMin(): string {
    if (this.endMin != null) {
      return this.endMin;
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _endMin(value: string) {
    this.$emit("update:endMin", value);
    return;
  }

  public getYearDisable() {
    return !this.showYear;
  }

  public getMonthDisabled(): boolean {
    if (this.year != "") {
      return false;
    } else {
      return true;
    }
  }

  public getDayDisabled(): boolean {
    if (this.year != "" && this.month != "") {
      return false;
    } else {
      return true;
    }
  }

  public getStartHourDisabled(): boolean {
    if (this.year != "" && this.month != "" && this.day != "") {
      return false;
    } else {
      return true;
    }
  }

  public getStartMinDisabled(): boolean {
    if (this.year != "" && this.month != "" && this.day != "" && this.startHour != "") {
      return false;
    } else {
      return true;
    }
  }

  public getStayCountDisabled(): boolean {
    if (this.year != "" && this.month != "" && this.day != "" && this.startHour != "" && this.startMin != "") {
      return false;
    } else {
      return true;
    }
  }

  public getEndHourDisabled(): boolean {
    if (this.year != "" && this.month != "" && this.day != "" && this.startHour != "" && this.startMin != "") {
      return false;
    } else {
      return true;
    }
  }

  public getEndMinDisabled(): boolean {
    if (this.year != "" && this.month != "" && this.day != "" && this.startHour != "" && this.startMin != "" && this.endHour != "") {
      return false;
    } else {
      return true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.input-going-out-datetime {
  .register-form {
    &.disable {
      cursor: not-allowed;
      background-color: $btn-disable !important;
      color: $btn-font-disable !important;
      transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
    }
  }
}
</style>
